class SearchForm extends HTMLElement {
  static fields = ['title', 'body', 'product_type', 'tag', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];

  static displayQuery(query = '') {
    if (!query.startsWith('(title:"') || !query.endsWith('")')) return query;
    const groups = query.slice(1, -1).split(') AND (');
    const words = [];
    for (const group of groups) {
      const word = group.slice('title:"'.length).split('" OR body:"')[0];
      if (!word || word.includes('"') || word.includes('\\')) return query;
      const expected = SearchForm.fields.map((field) => `${field}:"${word}"`).join(' OR ');
      if (group !== expected) return query;
      words.push(word);
    }
    return words.join(' ');
  }

  static preciseQuery(query = '') {
    const term = query.trim();
    if (!term || SearchForm.displayQuery(term) !== term) return term;
    if (
      /["\\*]/.test(term) ||
      /(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(term) ||
      /(?:^|[\s(])(?:title|body|product_type|tag|vendor|variants\.(?:title|sku|barcode)):/.test(term)
    ) return term;
    return term.split(/\s+/).map((word) => `(${SearchForm.fields.map((field) => `${field}:"${word}"`).join(' OR ')})`).join(' AND ');
  }

  static queryUrl(searchUrl, query, similar = false) {
    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', similar ? SearchForm.displayQuery(query) : SearchForm.preciseQuery(query));
    url.searchParams.set('type', 'product');
    if (similar) url.searchParams.set('dragenz_search', 'similar');
    else url.searchParams.delete('dragenz_search');
    return url;
  }

  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.queryInput = this.input.form.querySelector('[data-search-query]');
      if (this.queryInput) {
        this.input.removeAttribute('name');
        this.queryInput.name = 'q';
        this.input.form.addEventListener('submit', this.onQuerySubmit.bind(this));
      }
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onQuerySubmit(event) {
    if (!event.defaultPrevented && this.queryInput) {
      this.queryInput.value = SearchForm.preciseQuery(this.input.value);
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      if (this.queryInput) this.queryInput.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

